import React, {Fragment, useCallback, useRef, useState} from "react";
import Input from "../Input";
import {PasswordErrors} from "@ui-components/forms/PasswordErrors";
import sharedApiRequest from "@services/apiRequest";
import {CancelToken} from "axios";
import _ from "lodash";

const ChosePassword = ({setPassword, password, showPassword, setValidPassword}) => {

  const [passwordError, setPasswordError] = useState([]);

  const lastQuery = useRef();

  const handlePassword = useCallback(async (value) => {
    if (lastQuery.current) {
      lastQuery.current();
    }

    try {
      const errors = await sharedApiRequest.post("/users/password/check", value, {
        publicRequest: true,
        cancelToken: new CancelToken(function executor(c) {
          lastQuery.current = c;
        }),
        headers: {"Content-Type": "application/json"},
      });
      lastQuery.current = null;
      if (errors?.length > 0) {
        setPasswordError(() => errors);
        setValidPassword(false);
        return false;
      } else {
        setPasswordError(() => []);
        setValidPassword(true);
      }
    } catch (e) {
      console.log(e)
      if (lastQuery.current && e.message === "canceled") {
        return;
      }
    }
    return true;
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div>
        <Input
          value={password}
          onInput={(e) => {
            _.debounce(() => handlePassword(e.target.value), 100)();
            setPassword(e.target.value);
          }}
          label="Password"
          type={showPassword ? "text" : "password"}
          required
          showErrorDialog={false}
        />
        <PasswordErrors errors={passwordError}/>
      </div>
    </Fragment>
  );
};

export default ChosePassword;
